import { Observable } from 'rxjs'
import { MbProductTabReference } from '../../../models'

export abstract class MbProductTabReferencesAdapter {

  abstract load(productCode: string, maxCount?: number): Observable<MbProductTabReference[]>
}
